import { useState, createElement } from 'react';

const STORAGE_KEY = 'bb-docs:ai-disclosure-accepted';

const EU_AI_ICON_DATA_URI = `data:image/svg+xml;base64,${btoa('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32"><rect width="32" height="32" rx="4" fill="#003399"/><text x="16" y="12" text-anchor="middle" fill="#FFCC00" font-size="8" font-weight="700" font-family="Arial">EU</text><text x="16" y="22" text-anchor="middle" fill="#FFCC00" font-size="6" font-weight="600" font-family="Arial">AI</text><rect x="3" y="25" width="26" height="4" rx="1" fill="#FFCC00"/><text x="16" y="28.5" text-anchor="middle" fill="#003399" font-size="3.5" font-weight="700" font-family="Arial">ACT</text></svg>')}`;

export function hasAcceptedDisclosure(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'v1';
  } catch {
    return false;
  }
}

export function AiDisclosureModal({ onAccept }: { onAccept: () => void }) {
  return createElement('div', { className: 'disclosure-modal-overlay' },
    createElement('div', { className: 'disclosure-modal' },
      createElement('div', { className: 'eu-badge' },
        createElement('img', { src: EU_AI_ICON_DATA_URI, alt: 'EU AI Act', width: 20, height: 20 }),
        'EU AI Act Compliance',
      ),
      createElement('h2', null, 'AI-Generated Video Disclosure'),
      createElement('p', null, 'You are about to create an AI-generated video. Under EU Regulation 2024/1689 (Article 50), all AI-generated content must be clearly labelled.'),
      createElement('p', null, 'By proceeding, you acknowledge:'),
      createElement('ul', null,
        createElement('li', null, 'The video will be automatically labelled with the EU AI icon'),
        createElement('li', null, 'A C2PA manifest will be recorded in the audit trail'),
        createElement('li', null, 'Content is scanned for policy violations before storage'),
        createElement('li', null, 'Generation metadata is preserved for 7 years'),
        createElement('li', null, 'A compliance report is available for this content'),
      ),
      createElement('p', null,
        createElement('strong', null, 'This content is synthetically generated and does not depict real events.'),
      ),
      createElement('button', {
        className: 'disclosure-accept-btn',
        onClick: () => {
          try { localStorage.setItem(STORAGE_KEY, 'v1'); } catch {}
          onAccept();
        },
      }, 'I understand \u2014 Continue'),
    ),
  );
}

export function useAiDisclosure() {
  const [showModal, setShowModal] = useState(false);

  const requireDisclosure = (onAccepted: () => void) => {
    if (hasAcceptedDisclosure()) {
      onAccepted();
    } else {
      setShowModal(true);
    }
  };

  const AcceptanceModal = showModal
    ? createElement(AiDisclosureModal, {
        onAccept: () => {
          setShowModal(false);
        },
      })
    : null;

  return { requireDisclosure, AcceptanceModal };
}
